import { render } from "./ChangePermission.vue?vue&type=template&id=0ed13d58&scoped=true"
import script from "./ChangePermission.vue?vue&type=script&lang=js"
export * from "./ChangePermission.vue?vue&type=script&lang=js"

import "./ChangePermission.vue?vue&type=style&index=0&id=0ed13d58&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-0ed13d58"]])

export default __exports__